import { render, staticRenderFns } from "./MixCliente2.vue?vue&type=template&id=1f895c3b&scoped=true&"
import script from "./MixCliente2.vue?vue&type=script&lang=js&"
export * from "./MixCliente2.vue?vue&type=script&lang=js&"
import style0 from "./MixCliente2.vue?vue&type=style&index=0&id=1f895c3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f895c3b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
